// extracted by mini-css-extract-plugin
module.exports = {"root":"root_root__V12eH","container":"root_container__2SI9v","grid":"root_grid__362kz","section":"root_section__f0BdI"};